import { Trans, useTranslation } from 'react-i18next'

import { EnvelopeIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CheckYourEmailModal = ({
  show,
  email,
  merchantName,
  secondsToResend,
  loading,
  onResend,
  onUseDifferentEmail,
}) => {
  const { t } = useTranslation()
  const theme = useTheme()

  const isCoolingDown = secondsToResend > 0
  const isResendDisabled = isCoolingDown || loading
  const resendLabel = isCoolingDown
    ? t('Reenviar en {{seconds}} s', { seconds: secondsToResend })
    : t('Reenviar enlace')

  return (
    <Modal
      show={show}
      onClose={onUseDifferentEmail}
      size="m"
      blockOnClose={loading}
      actions={
        <Styles.Actions>
          <Button fullWidth disabled={isResendDisabled} onClick={onResend}>
            {resendLabel}
          </Button>
          <Button fullWidth variant="text" disabled={loading} onClick={onUseDifferentEmail}>
            {t('Usar otro email')}
          </Button>
        </Styles.Actions>
      }
    >
      <Styles.Content>
        <EnvelopeIcon size={40} color={theme.title.primary} />
        <Text type="titleM">{t('Revisa tu email')}</Text>
        <Text type="bodyMRegular">
          <Trans i18nKey="checkYourEmailMessage" values={{ email, merchant: merchantName }}>
            Si <strong>{{ email }}</strong> tiene pedidos recientes en {{ merchant: merchantName }}, te hemos enviado un
            enlace para verlos.
          </Trans>
        </Text>
        <Text type="bodyMRegular">{t('El enlace es válido durante las próximas 2 horas.')}</Text>
      </Styles.Content>
    </Modal>
  )
}

export default CheckYourEmailModal
